import {AllDeviceActivity, StatusDeviceActivity} from "@containers/device/containers/deviceActivity/types";
import {
    getColorByDeviceActivityStatus,
    getColorByDeviceActivityTotalKey
} from "@containers/device/containers/deviceActivity/helpers/getColorByDeviceActivityStatus";
import {
    getLabelStatusDeviceActivity,
    getLabelTotalDeviceActivity
} from "@containers/device/containers/deviceActivity/helpers/getLabelStatusDeviceActivity";

export const STATUSES_DEVICE_ACTIVITY: {
    value: StatusDeviceActivity,
    label: string,
    color: string,
}[] = [
    {
        value: 'online',
        label: getLabelStatusDeviceActivity('online'),
        color: getColorByDeviceActivityStatus('online')
    },
    {
        value: 'oneHour',
        label: getLabelStatusDeviceActivity('oneHour'),
        color: getColorByDeviceActivityStatus('oneHour')
    },
    {
        value: 'lastDay',
        label: getLabelStatusDeviceActivity('lastDay'),
        color: getColorByDeviceActivityStatus('lastDay')
    },
    {
        value: 'lastWeek',
        label: getLabelStatusDeviceActivity('lastWeek'),
        color: getColorByDeviceActivityStatus('lastWeek')
    },
    {
        value: 'lastMonth',
        label: getLabelStatusDeviceActivity('lastMonth'),
        color: getColorByDeviceActivityStatus('lastMonth')
    },
    {
        value: 'beforeLastMonth',
        label: getLabelStatusDeviceActivity('beforeLastMonth'),
        color: getColorByDeviceActivityStatus('beforeLastMonth')
    },
    {
        value: 'notConnected',
        label: getLabelStatusDeviceActivity('notConnected'),
        color: getColorByDeviceActivityStatus('notConnected')
    },
    {
        value: 'inactive',
        label: getLabelStatusDeviceActivity('inactive'),
        color: getColorByDeviceActivityStatus('inactive')
    },
]

export const STATUSES_DEVICE_ACTIVITY_TOTAL: {
    value: keyof AllDeviceActivity,
    label: string,
    color: string,
}[] = [
    {
        value: 'totalOnline',
        label: getLabelTotalDeviceActivity('totalOnline'),
        color: getColorByDeviceActivityTotalKey('totalOnline')
    },
    {
        value: 'totalOneHour',
        label: getLabelTotalDeviceActivity('totalOneHour'),
        color: getColorByDeviceActivityTotalKey('totalOneHour')
    },
    {
        value: 'totalLastDay',
        label: getLabelTotalDeviceActivity('totalLastDay'),
        color: getColorByDeviceActivityTotalKey('totalLastDay')
    },
    {
        value: 'totalLastWeek',
        label: getLabelTotalDeviceActivity('totalLastWeek'),
        color: getColorByDeviceActivityTotalKey('totalLastWeek')
    },
    {
        value: 'totalLastMonth',
        label: getLabelTotalDeviceActivity('totalLastMonth'),
        color: getColorByDeviceActivityTotalKey('totalLastMonth')
    },
    {
        value: 'totalBeforeLastMonth',
        label: getLabelTotalDeviceActivity('totalBeforeLastMonth'),
        color: getColorByDeviceActivityTotalKey('totalBeforeLastMonth')
    },
    {
        value: 'totalNotConnected',
        label: getLabelTotalDeviceActivity('totalNotConnected'),
        color: getColorByDeviceActivityTotalKey('totalNotConnected')
    },
    {
        value: 'totalInactive',
        label: getLabelTotalDeviceActivity('totalInactive'),
        color: getColorByDeviceActivityTotalKey('totalInactive')
    },
]